import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import App from './App.tsx';
import StateHubPage from './pages/StateHubPage.tsx';
import IntentPage from './pages/IntentPage.tsx';
import NotFoundPage from './pages/NotFoundPage.tsx';
import DraftsPage from './pages/DraftsPage.tsx';
import { STATE_HUBS } from './lib/trailHubs';
import { INTENT_PAGES } from './lib/intentPages';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        {STATE_HUBS.map((hub) => (
          <Route key={hub.state} path={`/${hub.slug}`} element={<StateHubPage slug={hub.slug} />} />
        ))}
        {INTENT_PAGES.map((page) => (
          <Route key={page.slug} path={`/${page.slug}`} element={<IntentPage slug={page.slug} />} />
        ))}
        <Route path="/willamette-valley-truffle-guide" element={<Navigate to="/oregon-truffle-guide" replace />} />
        <Route path="/oregon-truffle-chapter" element={<Navigate to="/oregon-truffle-guide" replace />} />
        <Route path="/drafts" element={<DraftsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);



